import React, { useState } from "react";
import { Form, Input, Button, Card, message } from "antd";
import { useNavigate } from "react-router-dom";
import { apiService } from "@/services/api";

export const TypeCreate: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      await apiService.createType({ title: values.title });
      message.success("Type de contenu créé");
      navigate("/types");
    } catch (e: any) {
      message.error("Erreur lors de la création du type");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card title="Créer un type de contenu">
      <Form layout="vertical" onFinish={onFinish} style={{ maxWidth: 500 }}>
        <Form.Item
          label="Titre"
          name="title"
          rules={[{ required: true, message: "Le titre est requis" }]}
        >
          <Input placeholder="Ex: Film, Série, Documentaire..." />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Créer
          </Button>
          <Button style={{ marginLeft: 8 }} onClick={() => navigate("/types")}>
            Annuler
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default TypeCreate;
